import React from "react";
import { Dialog, DialogContent, Stack, Typography } from "@mui/material";
import { AskAMIBotIcon } from "Icons/Icons";
import PrivacyConditions from "./PrivacyConditions";
import { FormFooter } from "Common/Components";

interface IPrivacyPolicyProps {
  isOpen: boolean;
  onClose: () => void; // Add this prop to handle closing the dialog externally
}

export const PrivacyPolicy: React.FC<IPrivacyPolicyProps> = ({ isOpen, onClose }) => {
  return (
    <Dialog
      open={isOpen}
      aria-labelledby="terms-dialog-title"
      aria-describedby="terms-dialog-description"
      maxWidth="lg"
      fullWidth
      slotProps={{
        paper: {
          variant: "popup",
          sx: {
            padding: 0,
          },
        },
      }}
    >
      <DialogContent>
        <Stack sx={{ mt: 2, alignItems: "center", overflow: "hidden" }}>
          <AskAMIBotIcon sx={{ width: "36px", height: "36px" }} />
          <Stack spacing={1.5} sx={{ marginTop: 1 }}>
            <Typography
              id="confirm-dialog-title"
              variant="h4"
              sx={{ fontWeight: "fontWeightSemiBold", textAlign: "center" }}
              color="primary.main"
            >
              Privacy Policy
            </Typography>
          </Stack>
        </Stack>
        <Stack spacing={2} sx={{ mt: 2 }}>
          <PrivacyConditions />
        </Stack>
      </DialogContent>

      <FormFooter
        buttons={[
          {
            label: "Close",
            onClick: onClose,
            variant: "contained",
            color: "primary",
          },
        ]}
      />
    </Dialog>
  );
};
